import { render, staticRenderFns } from "./TermsOfServiceConfirm.vue?vue&type=template&id=3b6b0150&scoped=true&"
import script from "./TermsOfServiceConfirm.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServiceConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfServiceConfirm.vue?vue&type=style&index=0&id=3b6b0150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b0150",
  null
  
)

export default component.exports